import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-organizer-shared-layout-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class OrganizerSharedLayoutDashboardComponent {
  @Input() public footerClass: string;
  @Input() public fullWidth = false;
  @Input() public hasFooter = false;
  @Input() public hasHeader = true;
}
